import { GenericTooltip } from "@components/tooltip-container";
import { useLandingPageAnalyticsContext } from "@features/landing-page-analytics/hooks";
import { type SalesPageMetric } from "@north-beam/nb-client-side";

interface Props {
  onClose(): void;
  metric?: SalesPageMetric;
}

export const AboutPanelGeneric = ({ onClose, metric }: Props) => {
  const {
    filters: { attributionWindow },
  } = useLandingPageAnalyticsContext();
  if (!metric?.metadata?.tooltip) {
    return null;
  }

  const { tooltip, isLtv } = metric.metadata;

  return (
    <div className="text-xs py-2.5 px-3">
      <button
        className="text-primary font-semibold hover:bg-cosmic-5 pb-1"
        onClick={onClose}
      >
        <i className="fa-regular fa-sharp fa-arrow-left text-primary mr-1"></i>
        BACK
      </button>
      <div className="flex flex-col space-y-1">
        <div className="text-sm text-gray+1 font-light pt-2">
          Metric Category
        </div>
        <p>{tooltip.reported} reported</p>
        <div className="text-sm text-gray+1 font-light pt-2">What is it?</div>
        <p dangerouslySetInnerHTML={{ __html: tooltip.description }}></p>
        {tooltip.calculationInfo && (
          <>
            <div className="text-sm text-gray+1 font-light pt-2">
              How it&apos;s calculated
            </div>
            <p
              dangerouslySetInnerHTML={{ __html: tooltip.calculationInfo }}
            ></p>
          </>
        )}
        {tooltip.showAttributionWindowInfo && (
          <>
            <div className="text-sm text-gray+1 font-light pt-2">
              Attribution window
            </div>
            <p>
              {isLtv ? (
                "Reported transactions based on the lifetime of touchpoints."
              ) : (
                <>
                  Reported transactions took place within{" "}
                  <GenericTooltip
                    noInfoCircle
                    content={`Attribution window is set to "${attributionWindow} day"`}
                  >
                    <span className="text-primary">
                      [{attributionWindow} day]
                    </span>
                  </GenericTooltip>{" "}
                  of the touchpoint.
                </>
              )}
            </p>
          </>
        )}
      </div>
    </div>
  );
};
